import { useCallback } from "react";
import { getClientDomain, getToken } from "../utils/Common";

export const useClient = () => {

    const getClients = useCallback(async (signal) => {
        const response = await fetch(`${getClientDomain()}/clients/clients`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getToken()}`
            },
            signal: signal
        });

        const result = await response.json();
   
        if (Array.isArray(result?.payload) && result.payload.length > 0) {
            return result?.payload;
        } else if (result?.payload) {
            return { ...result, payload: [result.payload] };
        } else {
            return { ...result, payload: [] };
        }
    }, []);

    const getDetailClients = useCallback(async (signal, data) => {
        const response = await fetch(`${getClientDomain()}/clients/detailsClient`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getToken()}`
            },
            body: JSON.stringify(data),
            signal: signal
        });

        const result = await response.json();

        if (Array.isArray(result?.payload) && result.payload.length > 0) {
            return result?.payload;
        } else if (result?.payload) {
            return { ...result, payload: [result.payload] };
        } else {
            return { ...result, payload: [] };
        }
    }, []);

    const getClientRoles = useCallback(async (signal) => {
        const response = await fetch(`${getClientDomain()}/clients/roles`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getToken()}`
            },
            signal: signal
        });

        const result = await response.json();

        if (Array.isArray(result?.payload) && result.payload.length > 0) {
            return result?.payload;
        } else if (result?.payload) {
            return { ...result, payload: [result.payload] };
        } else {
            return { ...result, payload: [] };
        }
    }, []);

    const updateClient = useCallback(async (signal, data) => {
        const response = await fetch(`${getClientDomain()}/clients/updateClient`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getToken()}`
            },
            body: JSON.stringify(data),
            signal: signal
        });

        const result = await response.json();
        if (result?.payload?.length > 0) return {...result, payload: result.payload[0]};
        else return {...result};
    }
    , []);

    const getClientById = useCallback(async (signal, data) => {
        const response = await fetch(`${getClientDomain()}/clients/getClient`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getToken()}`
            },
            body: JSON.stringify(data),
            signal: signal
        });

        const result = await response.json();

        if (Array.isArray(result?.payload) && result.payload.length > 0) {
            return result?.payload;
        } else if (result?.payload) {
            return { ...result, payload: [result.payload] };
        } else {
            return { ...result, payload: [] };
        }
    }
    , []);

    const getListClientByRole = useCallback(async (signal) => {
        const response = await fetch(`${getClientDomain()}/clients/listClient`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getToken()}`
            },
            signal: signal
        });

        const result = await response.json();

        if (Array.isArray(result?.payload) && result.payload.length > 0) {
            return result?.payload;
        } else if (result?.payload) {
            return { ...result, payload: [result.payload] };
        } else {
            return { ...result, payload: [] };
        }
    }
    , []);

    return { getClients, getDetailClients, getClientRoles, updateClient, getClientById,getListClientByRole };

}